import { type FC } from 'react';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel.tsx';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton.tsx';

import styles from './MobilePhotoHeader.scss';

type Props = {
    onCloseModal?: () => void;
    title?: string;
};

const MobilePhotoHeader: FC<Props> = props => {
    const { onCloseModal, title } = props;

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                <HeadingLevel>
                    {Heading => <Heading className={styles.title}>{title}</Heading>}
                </HeadingLevel>
                {onCloseModal && (
                    <ModalCloseButton className={styles.closeButton} onClick={onCloseModal} />
                )}
            </div>
        </div>
    );
};

export default MobilePhotoHeader;
